import { render, staticRenderFns } from "./blocked-user-list.html?vue&type=template&id=245c40ab&scoped=true&"
import script from "./blocked-user-list.js?vue&type=script&lang=js&"
export * from "./blocked-user-list.js?vue&type=script&lang=js&"
import style0 from "./blocked-user-list.scss?vue&type=style&index=0&id=245c40ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c40ab",
  null
  
)

export default component.exports